<template>
  <div style="display: flex;">
    <div>
      <label>包名：</label>
      <el-select v-model="packageNameNew" placeholder="Select" style="width: 10em" @change="packageChange">
        <el-option v-for="item in packageNameArray" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div style="margin-left: 20px;">
      <label>渠道：</label>
      <el-select v-model="channelNew" placeholder="Select" style="width: 10em" @change="channelChange">
        <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {channelPowerConfigPackageNames, listPackageNameAndChannel} from "@/api/url";

export default {
name: "ChannelPackageList",
  props: {
    packageName: {
      type: Number,
      default: 0,
    },
    channel: {
      type: Number,
      default: 0,
    },
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //渠道、包名
      packageNameArray: [
        {label: '不限', value: 0},
      ],
      packageNameNew: 0,
      channelArray: [
        {label: '不限', value: 0},
      ],
      channelNew: 0,
      channelPackageList: [],
    }
  },
  watch: {
    packageName() {
      this.packageNameNew = this.packageName
    },
    channel() {
      this.channelNew = this.channel
    },
    reload() {
      this.getChannelList();
    }
  },
  methods: {
    //包名、渠道
    getChannelList() {
      getFormData(listPackageNameAndChannel).then((data)=>{
        let {msg, code} = data;
        if(code == 200) {
          let dataList = data.data;
          this.channelPackageList = data.data;
          // for (let key in dataList) {
          //   let obj = {}
          //   obj.label = key
          //   obj.value = key
          //   this.packageNameArray.push(obj)
          // }
          dataList.map(item=>{
            let obj = {}
            obj.label = item.packageName
            obj.value = item.id
            this.packageNameArray.push(obj)
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    packageChange(val) {
      this.channelArray = [
        {label: '不限', value: 0},
      ]
      this.channelNew = 0
      if(val) {
        // this.channelPackageList[val].map(item=>{
        //   let obj = {}
        //   obj.label = item
        //   obj.value = item
        //   this.channelArray.push(obj)
        // })
        for(let i=0; i<this.channelPackageList.length; i++){
          if(val == this.channelPackageList[i].id) {
            this.channelPackageList[i].channelList.map(item=>{
              let obj = {}
              obj.label = item.channel
              obj.value = item.id
              this.channelArray.push(obj)
            })
          }
        }
      }
      this.$emit('getChange', [this.packageNameNew, this.channelNew])
    },

    channelChange() {
      this.$emit('getChange', [this.packageNameNew, this.channelNew])
    }

  },
  mounted() {
    this.getChannelList();
  }
}
</script>

<style scoped>

</style>
